import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export const exportClinicSummariesToExcel = (summaries = []) => {
  const worksheet = XLSX.utils.json_to_sheet(
    summaries.map((summary) => ({
      "Clinic Name": summary.clinicName,
      "Last Order": summary.lastOrderDate
        ? summary.lastOrderDate.toISOString().split("T")[0]
        : "",
      "Fulfillment Pharmacy": summary.fulfillmentPharmacy,
      "Total Orders": summary.totalOrders,
    })),
  );

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clinic Orders");
  XLSX.writeFile(workbook, "clinic-orders.xlsx");
};

export const exportClinicSummariesToPDF = (summaries = []) => {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text("Clinic Orders", 14, 20);
  doc.setFontSize(11);
  doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 28);

  autoTable(doc, {
    startY: 36,
    head: [["Clinic", "Last Order", "Pharmacy", "Total Orders"]],
    body: summaries.map((summary) => [
      summary.clinicName,
      summary.lastOrderDate ? summary.lastOrderDate.toLocaleDateString() : "-",
      summary.fulfillmentPharmacy,
      summary.totalOrders,
    ]),
    styles: { fontSize: 10 },
    headStyles: { fillColor: [37, 99, 235] },
  });

  doc.save("clinic-orders.pdf");
};

export const exportClinicOrdersToExcel = (orders = []) => {
  const worksheet = XLSX.utils.json_to_sheet(
    orders.map((order) => ({
      "Order ID": order.id,
      Date: order.date ? order.date.toISOString().split("T")[0] : "",
      "Fulfillment Pharmacy": order.fulfillmentPharmacy,
      Status: order.statusLabel || order.status,
    })),
  );

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clinic Orders Detail");
  XLSX.writeFile(workbook, "clinic-orders-detail.xlsx");
};

export const exportClinicOrdersToPDF = (orders = [], clinicName = "") => {
  const doc = new jsPDF();
  const title = clinicName ? `Clinic Orders - ${clinicName}` : "Clinic Orders - Detail";

  doc.setFontSize(16);
  doc.text(title, 14, 20);
  doc.setFontSize(11);
  doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 28);

  autoTable(doc, {
    startY: 36,
    head: [["Order ID", "Date", "Fulfillment Pharmacy", "Status"]],
    body: orders.map((order) => [
      order.id,
      order.date ? order.date.toLocaleDateString() : "-",
      order.fulfillmentPharmacy,
      order.statusLabel || order.status,
    ]),
    styles: { fontSize: 10 },
    headStyles: { fillColor: [37, 99, 235] },
  });

  doc.save("clinic-orders-detail.pdf");
};

export const exportCreditUsageToExcel = (creditUsage = []) => {
  const worksheet = XLSX.utils.json_to_sheet(
    creditUsage.map((usage) => ({
      "Clinic Name": usage.clinicName,
      Channel: usage.channelType,
      "Total Credits": usage.totalCredit,
      "Used Credits": usage.usedCredits,
      "Remaining Credits": usage.remainingCredits,
      "Used Messages": usage.usedMessages,
      "Overused Messages": usage.overUsedMessages,
      "Revenue (QAR)": usage.revenue,
    })),
  );

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Messaging");
  XLSX.writeFile(workbook, "clinic-messaging.xlsx");
};

export const exportCreditUsageToPDF = (creditUsage = []) => {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text("Clinic Channel Credits", 14, 20);
  doc.setFontSize(11);
  doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 28);

  autoTable(doc, {
    startY: 36,
    head: [
      [
        "Clinic",
        "Channel",
        "Total Credits",
        "Used",
        "Remaining",
        "Used Messages",
        "Overused",
        "Revenue (QAR)",
      ],
    ],
    body: creditUsage.map((usage) => [
      usage.clinicName,
      usage.channelType,
      usage.totalCredit?.toLocaleString() ?? "0",
      usage.usedCredits?.toLocaleString() ?? "0",
      usage.remainingCredits?.toLocaleString() ?? "0",
      usage.usedMessages?.toLocaleString() ?? "0",
      usage.overUsedMessages?.toLocaleString() ?? "0",
      `${(usage.revenue ?? 0).toLocaleString()}`,
    ]),
    styles: { fontSize: 10 },
    headStyles: { fillColor: [37, 99, 235] },
  });

  doc.save("clinic-channel-credits.pdf");
};

